let API_URL = 'https://liveapi.aiducator.ae';
// let API_URL = 'https://aiducatortestingapisv2.ctsdemo.ae';

export { API_URL };
